'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CP_GO_URL_REGEX = exports.CP_GO_URL_REGEX = /^(\/try)?\/go($|\/)/;
var CP_GO_URL_FAQ = exports.CP_GO_URL_FAQ = 'https://help.classpass.com/hc/en-us/categories/360000743812-ClassPass-Go';